import { ReactNode } from "react";
import { inverse_key_value } from "../functions.ts";
import { BASE_ASSET_URL } from "../config.ts";

export type GebaeudeTyp = "sfh" | "thm" | "the" | "mfh" | "mfm" | "mfe";

export const GEBAEUDE_TYP_OPTIONS: Array<{
  label: string;
  value: GebaeudeTyp;
  image: string;
}> = [
  { label: "Ein- und Zweifamilienhaus", value: "sfh", image: BASE_ASSET_URL + "house_previews/einfamilienhaus.jpg" },
  { label: "Reihenmittelhaus", value: "thm", image: BASE_ASSET_URL + "house_previews/reihenmittelhaus.jpg" },
  { label: "Reiheneckhaus", value: "the", image: BASE_ASSET_URL + "house_previews/reiheneckhaus.jpg" },
  { label: "Mehrfamilienhaus", value: "mfh", image: BASE_ASSET_URL + "house_previews/mehrfamilienhaus.jpg" },
  { label: "Mehrfamilienmittelhaus", value: "mfm", image: BASE_ASSET_URL + "house_previews/mehrfamilienmittelhaus.jpg" },
  { label: "Mehrfamilieneckhaus", value: "mfe", image: BASE_ASSET_URL + "house_previews/mehrfamilieneckhaus.jpg" },
];

// export const HEIZUNG_OPTIONS: Array<{ label: string; value: GebaeudeTyp }> = [
//   { label: "Öl", value: "oel" },
//   { label: "Gas", value: "gas" },
// ];

export interface MeasureWidget {
  key: string;
  widget: () => ReactNode;
  edit_dialog: () => ReactNode;
}

export interface StatisticWidget {
  key: string;
  widget: () => ReactNode;
}

export interface MenuItem{
    id: string,
    label: string,
}

export const MENU_ITEMS = [
  {
    id: "heizung",
    label: "Heizung",
  },
  { id: "keller", label: "Keller" },
  { id: "dach", label: "Dach" },
  {
    id: "fenster",
    label: "Fenster",
  },
  {
    id: "fassade",
    label: "Fassade",
  },
  {
    id: "solarthermie",
    label: "Solarthermie",
  },
  {
    id: "photovoltaik",
    label: "Photovoltaik",
  },
  {
    id: "lueftung",
    label: "Lüftung",
  },
];

export type ImageOption = {
  label: string;
  value: string;
  image: string;
};
export type Option = {
  label: string;
  value: string;
};

function  option_from_key_value(labels: Record<string,string>) : Array<Option>{
  return Object.keys(labels).map((key) => ({label: key, value: labels[key]}));
}

export const VERBRAUCHS_EINHEITEN_OEL: Array<Option> = option_from_key_value({
  "Liter":"liter",
});

export const VERBRAUCHS_EINHEITEN_GAS: Array<Option> = option_from_key_value({
  "kWh":"kWh",
  "m³": "m3"
});

export const VERBRAUCHS_EINHEITEN_HOLZ: Array<Option> = option_from_key_value({
  "kg": "kg",
  "m³":"m3",
  "t": "t"
});

export const VERBRAUCHS_EINHEITEN: Array<Option> = option_from_key_value({
  "kWh":"kWh",
});

export const ROOF_ORIENTATIONS: Array<Option> = option_from_key_value({
  "Süden":"S",
  "Südwesten":"SW",
  "Westen":"W",
  "Nordwesten":"NW",
  "Norden":"N",
  "Nordosten":"NO",
  "Osten":"O",
  "Südosten":"SO",
});

export const MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT: Array<Option> = option_from_key_value({
  "Öl-Konstanttemperaturkessel": "heating_system_current_0",
  "Gas-Konstanttemperaturkessel": "heating_system_current_1",
  "Holz- / Pelletkessel": "heating_system_current_2",
  "Luft-Wasser Wärmepumpe": "heating_system_current_3",
  "Sole-Wasser Wärmepumpe": "heating_system_current_4",
  "Elektrodirektheizung": "heating_system_current_5",
  "Fernwärme": "heating_system_current_6",
  "Gas-Niedertemperaturkessel": "heating_system_current_7",
  "Öl-Niedertemperaturkessel": "heating_system_current_8",
  "Gas-Brennwert": "heating_system_current_9",
  "Öl-Brennwert": "heating_system_current_10"
});

export const HOTWATER_OPTIONS: Array<Option> = option_from_key_value({
  "Keine zusätzliche Heißwassererzeugung":"",
  "Solarthermie":"solarthermal",
  "Photovoltaik":"photovoltaics",
  "Holz- / Pelletkessel":"heating_system_current_2",
  "Luft-Wasser Wärmepumpe":"heating_system_current_3",
  "Sole-Wasser Wärmepumpe":"heating_system_current_4",
  "Elektrodirektheizung":"heating_system_current_5",
});

export const MASSNAHMEN_HEIZUNG_OPTIONS_NEW: Array<Option> = option_from_key_value({
  "nicht sanieren": "heating_system_planned_0",
  "Sole-Wasser Wärmepumpe": "heating_system_planned_1",
  "Luft-Wasser Wärmepumpe": "heating_system_planned_2",
  "Luft-Wärmepumpe / Gas-Brennwert": "heating_system_planned_3",
  "Luft-Wärmepumpe / Öl-Brennwert": "heating_system_planned_4",
  "Brennstoffzellenheizung": "heating_system_planned_6",
  "Holz- / Pelletkessel": "heating_system_planned_7",
  "Gas-Brennwert": "heating_system_planned_8",
  "Öl-Brennwert": "heating_system_planned_9",
})

export const MASSNAHMEN_FENSTER_OPTIONS_CURRENT: Array<Option> = option_from_key_value({
   "nicht saniert": "window_current_0",
    "1-fach-Verglasung": "window_current_1",
    "2-fach-Isolierverglasung": "window_current_2",
    "2-fach-Wärmeschutzverglasung": "window_current_3",
    "3-fach-Wärmeschutzverglasung": "window_current_4",
});

export const MASSNAHMEN_FENSTER_OPTIONS_NEW: Array<Option> = option_from_key_value({
    "nicht sanieren":"window_planned_0",
    "2-fach Wärmeschutzverglasung":"window_planned_1",
    "3-fach Wärmeschutzverglasung U-Wert 0,95":"window_planned_2",
});

export const MASSNAHMEN_DACH_OPTIONS_CURRENT: Array<Option> = option_from_key_value({
    "nicht gedämmt": "roof_insulation_current_0",
      "Dämmung, 10 cm": "roof_insulation_current_1",
      "Dämmung, 12 cm": "roof_insulation_current_2",
      "Dämmung, 14 cm": "roof_insulation_current_3",
      "Dämmung, 16 cm": "roof_insulation_current_4",
      "Dämmung, 18 cm": "roof_insulation_current_5",
      "Dämmung, 20 cm": "roof_insulation_current_6",
});

export const MASSNAHMEN_DACH_OPTIONS_NEW:  Array<Option> = option_from_key_value({
   "nicht sanieren": "roof_insulation_planned_0",
    "Zwischensparren 16 cm/WLG 024 GEG": "roof_insulation_planned_3",
    "Zwischen- u. Aufsparren 16 cm/WLG 032 + 12 cm/WLG 042 BEG": "roof_insulation_planned_4",
    "Aufsparren 8 cm/WLG 020 GEG": "roof_insulation_planned_5",
    "Aufsparren 12.5 cm/WLG 020 BEG": "roof_insulation_planned_6",
    "Aufsparren 16 cm/WLG 042 GEG": "roof_insulation_planned_7",
    "Aufsparren 25 cm/WLG 042 BEG": "roof_insulation_planned_8",
    "Massivdecke 14 cm/WLG 035 GEG": "roof_insulation_planned_11",
    "Massivdecke 24 cm/WLG 034 BEG": "roof_insulation_planned_12",
    "Holzbalkendecke 14 cm/WLG 032 GEG": "roof_insulation_planned_13",
    "Holzbalkendecke 28 cm/WLG 032 BEG": "roof_insulation_planned_14",
});

// export const MASSNAHMEN_DACH_OPTIONS_NEW_DECKE: Array<Option> = option_from_key_value({
//   "nicht sanieren":"roof_insulation_planned_0",
//   "Massivdecke 14 cm/WLG 035":"roof_insulation_planned_11",
//   "Massivdecke 24 cm/WLG 034":"roof_insulation_planned_12",
//   "Holzbalkendecke 14 cm/WLG 032":"roof_insulation_planned_13",
//   "Holzbalkendecke 28 cm/WLG 032":"roof_insulation_planned_14",
// });

export const MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT: Array<Option> = option_from_key_value({
  "keine Lüftung":"ventilation_system_current_0",
  "Abluft-Anlage":"ventilation_system_current_1",
  "Lüftung mit Wärmerückgewinnung":"ventilation_system_current_2",
});

export const MASSNAHMEN_LUEFTUNG_OPTIONS_NEW: Array<Option> = option_from_key_value({
  "nicht sanieren":"ventilation_system_planned_0",
  "Lüftung mit Wärmerückgewinnung":"ventilation_system_planned_1",
  "Abluft-Anlage":"ventilation_system_planned_2", 
});

export const MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT: Array<Option> = option_from_key_value({
  "keine Solaranlage":"solar_thermal_current_0",
  "Solaranlage Warmwasser": "solar_thermal_current_1",
  "Solaranlage Warmwasser + Heizung": "solar_thermal_current_2",
});

export const MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW: Array<Option> = option_from_key_value({
  "nicht sanieren ": "solar_thermal_planned_0",
  "Solaranlage Warmwasser": "solar_thermal_planned_1",
  "Solaranlage Warmwasser + Heizung": "solar_thermal_planned_2",
});

export const MASSNAHMEN_KELLER_OPTIONS_CURRENT: Array<Option> = option_from_key_value({
  "Kellerdecke nicht gedämmt": "floor_insulation_current_0",
  "Dämmung, 4 cm": "floor_insulation_current_1",
  "Dämmung, 6 cm": "floor_insulation_current_2",
  "Dämmung, 8 cm": "floor_insulation_current_3",
});

export const MASSNAHMEN_KELLER_OPTIONS_NEW: Array<Option> = option_from_key_value({
  "nicht sanieren": "floor_insulation_planned_0",
  "Dämmung, 8 cm WLG 035 GEG": "floor_insulation_planned_1",
  "Dämmung, 6 cm WLG 024 GEG": "floor_insulation_planned_2",
  "Dämmung, 10 cm WLG 033 BEG": "floor_insulation_planned_3",
  "Dämmung, 8 cm WLG 024 BEG": "floor_insulation_planned_4"
});

export const MASSNAHMEN_FASSADE_OPTIONS_CURRENT: Array<Option> = option_from_key_value({
   "nicht gedämmt": "facade_insulation_current_0",
   "Dämmung, 6 cm": "facade_insulation_current_1",
   "Dämmung, 8 cm": "facade_insulation_current_2",
   "Dämmung, 10 cm": "facade_insulation_current_3",
   "Dämmung, 12 cm": "facade_insulation_current_4",
   "Dämmung, 14 cm": "facade_insulation_current_5",
   "Dämmung, 16 cm": "facade_insulation_current_6",
});

export const MASSNAHMEN_FASSADE_OPTIONS_NEW: Array<Option> = option_from_key_value({
      "nicht sanieren": "facade_insulation_planned_0",
      "Dämmung, 14 cm WLG 035 GEG": "facade_insulation_planned_1",
      "Dämmung, 12 cm WLG 032 GEG": "facade_insulation_planned_2",
      "Dämmung, 16 cm WLG 040 GEG": "facade_insulation_planned_3",
      "Dämmung, 16 cm WLG 035 BEG": "facade_insulation_planned_4",
      "Dämmung, 14 cm WLG 032 BEG": "facade_insulation_planned_5",
      "Dämmung, 18 cm WLG 040 BEG": "facade_insulation_planned_6"

});
      

export const MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT: Array<Option> = option_from_key_value({
  "kein Photovoltaik": "photovoltaics_current_0",
  "Photovoltaik vorhanden": "photovoltaics_current_1",
});

export const MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW: Array<Option> = option_from_key_value({
  "keine Photovoltaik installieren": "photovoltaics_planned_0",
  "PV 4 kWp (4 kWh Batteriespeicher)": "photovoltaics_planned_1",
  "PV 6 kWp (6 kWh Batteriespeicher)": "photovoltaics_planned_2",
  "PV 8 kWp (8 kWh Batteriespeicher)": "photovoltaics_planned_3",
  "PV 10 kWp 10 kWh Batteriespeicher": "photovoltaics_planned_4",
});

export const ROOF_ORIENTATIONS_LABELS = inverse_key_value(ROOF_ORIENTATIONS);
export const MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT_LABELS = inverse_key_value(MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT);
export const MASSNAHMEN_HEIZUNG_OPTIONS_NEW_LABELS = inverse_key_value(MASSNAHMEN_HEIZUNG_OPTIONS_NEW);
export const MASSNAHMEN_FENSTER_OPTIONS_CURRENT_LABELS = inverse_key_value(MASSNAHMEN_FENSTER_OPTIONS_CURRENT);
export const MASSNAHMEN_FENSTER_OPTIONS_NEW_LABELS = inverse_key_value(MASSNAHMEN_FENSTER_OPTIONS_NEW);
export const MASSNAHMEN_DACH_OPTIONS_CURRENT_LABELS = inverse_key_value(MASSNAHMEN_DACH_OPTIONS_CURRENT);
export const MASSNAHMEN_DACH_OPTIONS_NEW_LABELS = inverse_key_value(MASSNAHMEN_DACH_OPTIONS_NEW);
export const MASSNAHMEN_DACH_OPTIONS_NEW_DECKE_LABELS = inverse_key_value(MASSNAHMEN_DACH_OPTIONS_NEW);
export const MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT_LABELS = inverse_key_value(MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT);
export const MASSNAHMEN_LUEFTUNG_OPTIONS_NEW_LABELS = inverse_key_value(MASSNAHMEN_LUEFTUNG_OPTIONS_NEW);
export const MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT_LABELS = inverse_key_value(MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT);
export const MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW_LABELS = inverse_key_value(MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW);
export const MASSNAHMEN_KELLER_OPTIONS_CURRENT_LABELS = inverse_key_value(MASSNAHMEN_KELLER_OPTIONS_CURRENT);
export const MASSNAHMEN_KELLER_OPTIONS_NEW_LABELS = inverse_key_value(MASSNAHMEN_KELLER_OPTIONS_NEW);
export const MASSNAHMEN_FASSADE_OPTIONS_CURRENT_LABELS = inverse_key_value(MASSNAHMEN_FASSADE_OPTIONS_CURRENT);
export const MASSNAHMEN_FASSADE_OPTIONS_NEW_LABELS = inverse_key_value(MASSNAHMEN_FASSADE_OPTIONS_NEW);
export const MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT_LABELS = inverse_key_value(MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT);
export const MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW_LABELS = inverse_key_value(MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW);

export interface ModalDeclaration{
  close_on_click_background: boolean;
  modal: () => ReactNode;
}

export interface StepDescription{
  id: string,
  label: string
}

export const STEPS : Array<StepDescription> = [
  {id: "base1", label: "Gebäudeart wählen"},
  {id: "base2", label: "Basisdaten Gebäude"},
  {id: "base3", label: "Basisdaten Heizung"},
  {id: "now", label: "Sanierungszustand"},
  {id: "future", label: "Geplante Maßnahmen"},
  {id: "calc", label: "Ergebnisse"},
  ];